<template>
    <div>
        <div v-if="readonly">
            <el-input :value="initialProfession" :placeholder="placeholder" type="text" name="profession" readonly></el-input>
        </div>
        <el-select v-else v-model="selected" :placeholder="placeholder" name="profession" @change="handleChange">
            <el-option
                    v-for="profession in professions"
                    :key="profession.id"
                    :label="profession.name"
                    :value="useDecodedId ? profession.professionId : profession.id ">
            </el-option>
        </el-select>
    </div>
</template>

<script>
    import store from '../store';

    export default {
        props: {
            initial: {
                type: [String, Number],
            },
            excludes: {
                type: Array,
                default: () => []
            },
            readonly: {
                type: Boolean,
                default: false
            },
            useDecodedId: {
                type: Boolean,
                default: false
            },
            placeholder: {
                type: String,
                default: 'Select one...'
            }
        },

        data() {
            return {
                selected: this.initial
            }
        },

        computed: {
            professions() {
                return this.$store.state.profession.items
                    .filter(profession => this.excludes.indexOf(profession.name) < 0)
            },

            device() {
                return this.$store.getters['ui/getDevice'];
            },

            initialProfession() {
                if (this.initial && this.professions.length) {
                    return this.professions.find(profession => profession.id === this.initial).name
                }
                return ''
            }
        },

        methods: {
            handleChange(profession) {
                this.$emit('change', profession);
            }
        },

        created() {
            !this.$store.state.profession && this.$store.registerModule('profession', store);

            this.$store.dispatch('profession/getAllProfessions');
        },

        watch: {
            initial(profession) {
                this.selected = profession;
            }
        }
    }
</script>
